import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import InfoIcon from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

import {NO_OP, priceIndicatorColorConfig, SIZES} from './config.js'

const CardAdPriceIndicator = ({
  average,
  offerTypeId,
  isClickable = true,
  onClick = NO_OP,
  rank,
  size = SIZES.small,
  withExtendedInfo = true,
  withIcon = true
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {OFFER_TYPE_NEW, OFFER_TYPE_SUBSCRIPTION} = config.get('search')
  const {PRICE_INDICATOR_VALUE_RANK, PRICE_INDICATOR_LABEL_RANK} = config.get('priceIndicator')
  const isRenting = offerTypeId === OFFER_TYPE_SUBSCRIPTION

  const hasAverageIndicator = Boolean(average) && !isRenting

  const cashLabelClassName = cx('mt-CardAdPrice-cashLabel', {
    [`mt-CardAdPrice-cashLabel--noWrap`]: !withIcon
  })
  const containerClassNames = cx(
    'mt-CardAdPrice-priceIndicatorContainer',
    `mt-CardAdPrice-priceIndicatorContainer--${SIZES[size]}`
  )
  const priceIndicatorClassName = cx('mt-CardAdPrice-priceIndicator', {
    'is-clickable': isClickable
  })

  const handleClick = () => onClick()

  const AVERAGE_LABEL = {
    [OFFER_TYPE_NEW]: i18n.t('COMMON.OFFICIAL_PRICE')
  }

  const averageLabel = AVERAGE_LABEL[offerTypeId] || i18n.t('COMMON.MARKET_VALUE')

  return (
    <div className={priceIndicatorClassName} onClick={handleClick}>
      <div className="mt-CardAdPrice-priceIndicatorTitle">
        <span className={cashLabelClassName}>{PRICE_INDICATOR_LABEL_RANK[rank]}</span>
        {withIcon && <InfoIcon size="small" />}
      </div>
      <div className={containerClassNames}>
        {priceIndicatorColorConfig(PRICE_INDICATOR_VALUE_RANK).map(itemConfig => {
          const colorModifier = itemConfig[rank]

          const itemClassName = cx(
            'mt-CardAdPrice-priceIndicatorContainerItem',
            `mt-CardAdPrice-priceIndicatorContainerItem--${colorModifier}`
          )
          return <span className={itemClassName} />
        })}
      </div>
      {hasAverageIndicator && withExtendedInfo && (
        <p className="mt-CardAdPrice-priceIndicatorAverage">
          {averageLabel} {i18n.c(average)}
        </p>
      )}
    </div>
  )
}

CardAdPriceIndicator.displayName = 'CardAdPriceIndicator'

CardAdPriceIndicator.propTypes = {
  average: PropTypes.number,
  offerTypeId: PropTypes.string,
  isClickable: PropTypes.bool,
  onClick: PropTypes.func,
  rank: PropTypes.number,
  size: PropTypes.oneOf(Object.values(SIZES)),
  withExtendedInfo: PropTypes.bool,
  withIcon: PropTypes.bool
}

export {SIZES as cardAdPriceIndicatorSizes}

export default CardAdPriceIndicator
